const STOP_WORDS = new Set([
    'the', 'a', 'an', 'of', 'and', 'or', 'for', 'to', 'in', 'on', 'with', 'by', 'from', 'at', 'as'
]);

// Filter function to normalize search terms and entries
export function normalizeForAutocomplete(input: string): string {
    const lower = input.toLowerCase();
    const words = lower.split(/\s+/);
    const filtered = words
        .filter(word => !STOP_WORDS.has(word))
        .join('');

    // Keep only a-z and 0-9
    const cleaned = filtered.replace(/[^a-z0-9]/g, '');

    // If only one character remains, it's invalid
    return cleaned.length <= 1 ? '' : cleaned;
}
